import { useSelector } from 'react-redux';

import { Anchor, Box, Page } from '@zillow/constellation-10';
import { PageFooter } from '@zillow/page-frame';

import StringConstants from '@common/constants/StringConstants';
import pathsManifest from '@renter-hub/pathsManifest';

import zillowRentalsLogo from 'assets/zillow-rentals.png';
import './index.scss';
import { onPageFrameLinkClick } from '@zg-rentals/datagrail';

interface PageTemplateProps {
  children: React.ReactNode;
}

const PageTemplate = ({ children }: PageTemplateProps) => {
  const { loggedIn, email, fromApp } = useSelector((state) => ({
    // @ts-expect-error
    loggedIn: state.user.loggedIn,
    // @ts-expect-error
    email: state.user.email,
    // @ts-expect-error
    fromApp: state.app.cookieEnabledServices.fromApp,
  }));

  const goToRenterHub = () => {
    window.location.href = pathsManifest.brandHomePage;
  };

  const goToSignInPage = () => {
    if (typeof window !== 'undefined') {
      const { pathname, search } = window.location;
      window.location = pathsManifest.signInPage({ pathname, search });
    }
  };

  const goToLogOutPage = () => {
    if (typeof window !== 'undefined') {
      window.location.href = pathsManifest.logOutPage();
    }
  };

  const isInMobileWebView = StringConstants.APP_SOURCES.includes(fromApp || '');

  return (
    <Page.Root css={{ background: 'white' }}>
      {!isInMobileWebView && (
        <Box
          css={{
            maxWidth: '1152px',
            margin: '0 auto !important',
            display: 'grid',
            gridTemplateColumns: '1fr auto 1fr',
            alignItems: 'center',
            borderBottom: '1px solid #d1d1d5',
            padding: 'token(spacing.sm) 0 !important',
          }}
        >
          <Box
            css={{
              fontWeight: 'unset !important',
              fontFamily: "'Open Sans', 'Adjusted Arial', Tahoma, Geneva, sans-serif !important",
            }}
          >
            <Anchor
              css={{ textDecoration: 'none', padding: 'token(spacing.sm)', float: 'left' }}
              onClick={goToRenterHub}
            >{`< ${StringConstants.BRANDS.FORMATTED.zillow} home`}</Anchor>
          </Box>
          <Box css={{ display: 'flex', justifyContent: 'center' }}>
            <img className="zillowLogoImg" alt="Zillow" src={zillowRentalsLogo as unknown as string} />
          </Box>
          <Box
            css={{
              fontWeight: 'unset !important',
              fontFamily: "'Open Sans', 'Adjusted Arial', Tahoma, Geneva, sans-serif !important",
            }}
          >
            {email && loggedIn ? (
              <Anchor
                css={{ textDecoration: 'none', padding: 'token(spacing.sm)', float: 'right' }}
                onClick={goToLogOutPage}
              >
                Sign out
              </Anchor>
            ) : (
              <Anchor
                css={{ textDecoration: 'none', padding: 'token(spacing.sm)', float: 'right' }}
                onClick={goToSignInPage}
              >
                Sign in
              </Anchor>
            )}
          </Box>
        </Box>
      )}
      <Page.Content>{children}</Page.Content>
      {!isInMobileWebView && (
        <Page.Content css={{ background: 'white' }}>
          <PageFooter onLinkClick={onPageFrameLinkClick} />
        </Page.Content>
      )}
    </Page.Root>
  );
};

export default PageTemplate;
